// extracted by mini-css-extract-plugin
export var component = "DashboardMenuLink-module--component--5SV9l";
export var current = "DashboardMenuLink-module--current--8vy5S";
export var inert = "DashboardMenuLink-module--inert--OLeVr";
export var label = "DashboardMenuLink-module--label--IPc5t";